
import { useMapEvents, Polyline } from 'react-leaflet';
import { useState, useEffect, useRef } from "react";
import * as turf from '@turf/turf';
import L from "leaflet";
import { groupMarkersByVetka, groupMarkersByCanton } from '../TerritoryFilter/GroupMarkersPolygon';
import { getPolygonPoints2 } from '../Drawing/LinePolygons';


const MarkerPoligonToClick = ({ switchesData, marker, markers, setMarkers, coordinates, setCoordinates, selectedCanton, housesData }) => {

  const markersByVetka = groupMarkersByVetka(housesData);
  const markersByCanton = groupMarkersByCanton(switchesData);


  useMapEvents({
    click: (e) => {
      if (marker) {
        const { lat, lng } = e.latlng;
        setMarkers([...markers, { lat, lng }]);
        
        const point = turf.point([lng, lat]);
        let foundInPolygon = false;
        let polygonInfo = 'вне области полигона';
        let flagTerritory;

        Object.keys(markersByCanton).forEach((canton) => {
          const coordinates = markersByCanton[canton];
          const polygonPoints = getPolygonPoints2(coordinates);
          if (polygonPoints) {
            const polygon = turf.polygon([polygonPoints.map(coord => [coord[1], coord[0]])]);
            if (turf.booleanPointInPolygon(point, polygon)) {
              foundInPolygon = true;
              polygonInfo = `${canton}`;
              flagTerritory = 'canton';
            }
          }
        });

        Object.keys(markersByVetka).forEach((vetka) => {
          const coordinates = markersByVetka[vetka];
          const polygonPoints = getPolygonPoints2(coordinates);
          if (polygonPoints) {
            const polygon = turf.polygon([polygonPoints.map(coord => [coord[1], coord[0]])]);
            if (turf.booleanPointInPolygon(point, polygon)) {
              foundInPolygon = true;
              polygonInfo = `${vetka}`;
              flagTerritory = 'area';
            }
          }
        });

        if (!foundInPolygon) {
          polygonInfo = selectedCanton;
          flagTerritory = 'city';
        }

        setCoordinates([...coordinates, { lat, lng, polygonInfo, flagTerritory }]);
      }
    },
  });
  return null;
};

export default MarkerPoligonToClick;
